<div id="mainComponentContainer">
    <div class="row">
        <div class="col-xl-12">
            <div class="card-box">
                <div v-show="!loading">
                    <data-table :headings="customerHeadings" :data="customers" :hasActions="true"
                                :pagingDetails="pagingDetails"
                                :stateChanged="filterStateChanged"
                                @pagingUpdated="onPagingUpdated"
                                @actionClicked="onCustomerActionClicked" @filterSearchClicked="onFilterSearchClicked">
                        <template #actionButton>
                            <div class="w-100">
                                <div class="dropdown">
                                    <button class="btn btn-primary dropdown-toggle" type="button" id="customerActionDropdown" data-toggle="dropdown" data-boundary="viewport" aria-haspopup="true" aria-expanded="false">
                                        Actions
                                    </button>
                                    <div class="dropdown-menu" aria-labelledby="customerActionDropdown">
                                        <button class="dropdown-item" @click="onAddCustomerClick" id="btnAddCustomer">
                                            Add Customer
                                        </button>
                                        <button class="dropdown-item" id="btnBulkTopUps" @click="showBulkImportModal">
                                            Upload Bulk Top Ups
                                        </button>
                                    </div>
                                </div>
<!--                                <button class="btn btn-primary" @click="onAddCustomerClick" id="btnAddCustomer">Add Customer</button>-->
                            </div>
                        </template>
                        <template #filter>
                            <div class="p-3">
                                <div class="input-group pb-4">
                                    <input type="text" class="form-control" placeholder="Search" aria-label="Search" aria-describedby="basic-addon1" v-model="filter.customerSearchQuery">
                                    <div class="input-group-append">
                                    <span class="input-group-text" id="basic-addon1">
                                        <i class="fas fa-search"></i>
                                    </span>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-6">
                                        <from-date-to-date-pickers  :title="'Date Created'"
                                                                    :fromDate="filter.fromDateCreated"
                                                                    :toDate="filter.toDateCreated"
                                                                    :elementId="'customerDateFilter'"
                                                                    :dateFormat="'DD/MM/YYYY'"
                                                                    @clearDatePicker="onDateFilterClearClick"
                                                                    @fromDateSelected="onFromDateCreatedSelect"
                                                                    @toDateSelected="onToDateCreatedSelect"></from-date-to-date-pickers>
                                    </div>
                                    <div class="col-sm-6 align-self-center">
                                        <div class="float-right pr-3">
                                            <active-inactive-radio-buttons :activeInactiveKey="filter.activeOrInactiveItems"
                                                                           :componentId="'customerFilterRadioButtons'"
                                                                           @activeInactiveSelected="onActiveInactiveFilterSelected"></active-inactive-radio-buttons>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </data-table>
                </div>
                <loading-spinner :showSpinner="loading"></loading-spinner>
            </div>
        </div>
    </div>

    <mark-as-active-inactive-modal
                :heading="customerMarkAsActiveInactiveModal.heading"
                :modalId="customerMarkAsActiveInactiveModal.modalId"
                :isSaving="customerMarkAsActiveInactiveModal.isSaving"
                :showModal="customerMarkAsActiveInactiveModal.showModal"
                :isActive="customerMarkAsActiveInactiveModal.isActive"
                @closeClicked="customerMarkAsActiveInactiveModal.showModal = false"
                @saveButtonClicked="onMarkAsActiveInactiveSaveClick"></mark-as-active-inactive-modal>
    
    <select-customer-order-modal
        :heading="selectCustomerOrderTypeModal.heading"
        :modalId="selectCustomerOrderTypeModal.modalId"
        :showModal="selectCustomerOrderTypeModal.showModal"
        :company="selectCustomerOrderTypeModal.selectedCompany"
        @closeClicked="onSelectCustomerOrderModalClick"></select-customer-order-modal>
    
    <customer-documents-modal
        :heading="customerDocumentsModal.heading"
        :modalId="customerDocumentsModal.modalId"
        :showModal="customerDocumentsModal.showModal"
        :companyId="customerDocumentsModal.companyId"
        @closeModal="onCustomerDocumentsModalClose"></customer-documents-modal>
    
    <bulk-credit-top-up-modal
        :showModal="bulkTopUpModal.showModal"
        @modal-close="onBulkImportModalClose"></bulk-credit-top-up-modal>

    <company-audit-modal
            :heading="customerViewAuditModal.heading"
            :modal-id="'companyAuditModal'"
            :show-modal="customerViewAuditModal.showModal"
            :company-id="customerViewAuditModal.companyId"
            @ok-button-clicked="onCompanyAuditModalClosed">
    </company-audit-modal>

    <company-order-audits-modal
            :heading="customerViewOrderAuditModal.heading"
            :modal-id="'companyOrderAuditsModal'"
            :show-modal="customerViewOrderAuditModal.showModal"
            :company-id="customerViewOrderAuditModal.companyId"
            @ok-button-clicked="onCompanyOrderAuditModalClosed">
    </company-order-audits-modal>
</div>
